// removed by extract-text-webpack-plugin
module.exports = {"chat":"ChatWindow_chat_12EHl","chatMsgsContainer":"ChatWindow_chatMsgsContainer_34aKD","chatWrapper":"ChatWindow_chatWrapper_3S9sp","docked":"ChatWindow_docked_1rWad","wismoIcon":"ChatWindow_wismoIcon_2Qkzm","categoriesWrapper":"ChatWindow_categoriesWrapper_1r2m7","categoryCard":"ChatWindow_categoryCard_yYPCk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChatWindow/ChatWindow.css
// module id = 120
// module chunks = 0